















































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import AceEditor from 'vue2-ace-editor';
import { ApiV2Service } from '@/services/api.base.service';
import 'brace/mode/javascript';
import 'brace/theme/clouds';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
    AceEditor,
  },
})
export default class DownlinkFunctions extends Vue {
  @Prop({ default: {} }) private deviceType: any;

  private showTestFunctionModal: boolean = false;
  private showTest: boolean = false;
  private testPayload: string = '';
  private testResponse: string = '';

  private DEFAULT_DOWNLINK_CREATE_FUNCTION = `(point, config) => {\n\treturn null;\n}`;
  private DEFAULT_DOWNLINK_ENCODE_FUNCTION = `(data) => {\n\tconst payload = Spec().write(data);\n\tconst port = data.config.port;\n\t// LoRA - an object containing the downlink data and the port needs to be retrieved \n\t// return {data: payload, port: port} \n\n\t// Sigfox - only the payload needs to be retrieved\n\treturn payload;\n}`;

  private saveDownlink() {
    this.$emit('saveDeviceType', this.deviceType);
  }

  private editorInit(editor: any) {
    editor.setOptions({
      fontSize: '1em',
    });
  }

  @Watch('deviceType', { deep: true, immediate: true })
  private setDefaultFunctions() {
    if (!this.deviceType.configuration.downlinkCreateFunction) {
      this.deviceType.configuration.downlinkCreateFunction = this.DEFAULT_DOWNLINK_CREATE_FUNCTION;
    }

    if (!this.deviceType.configuration.downlinkEncodeFunction) {
      this.deviceType.configuration.downlinkEncodeFunction = this.DEFAULT_DOWNLINK_ENCODE_FUNCTION;
    }
  }

  private async showTestFunction() {
    this.testResponse = '';
    this.showTest = true;
  }

  private async testFunction() {
    const { result } = await ApiV2Service.post(`admin/deviceVersion/test`, { code: this.deviceType.configuration.downlinkEncodeFunction, type: 'downlink_encode', executionVersion: `v1`, payload: this.testPayload, isJSON: true });
    this.testResponse = JSON.stringify(result, null, '\t');
    if (!this.testResponse) {
      this.testResponse = 'Empty response';
    }

  }
}
